import request from "@/utils/require";

// 产品列表
export function fetchGetProducts(categoryId) {
  return request({
    url: `/product/getList/${categoryId}`,
  });
}
